/** Spoljne aplikacije kluba (Right Decision) — javne stranice za roditelje, ugrađene u sajt kao iframe. */
export const SCHEDULE_URL = 'https://rightdecision.cloud/treninzi?tenant=fk-junior&embed=1';
export const TRANSPORT_URL = 'https://rightdecision.cloud/prevoz?tenant=fk-junior&embed=1';

/** Interne adrese na sajtu koje prikazuju gornje stranice. */
export const SCHEDULE_PATH = '/raspored/';
export const TRANSPORT_PATH = '/prevoz/';

/** Stranica turnira Junior Cup 2027, na jeziku sajta (svaki jezik ima svoju adresu). */
export const juniorCupPath = (lang: string): string => (lang && lang !== 'sr' ? `/junior-cup/${lang}/` : '/junior-cup/');
